var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SubPageTemplate',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("ジャンプアップ割引率")]},proxy:true},{key:"content",fn:function(){return [_c('DiscountRateList')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }